import { render } from "./inviteModal.vue?vue&type=template&id=dfe809d4"
import script from "./inviteModal.vue?vue&type=script&lang=js"
export * from "./inviteModal.vue?vue&type=script&lang=js"

import "./inviteModal.vue?vue&type=style&index=0&id=dfe809d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__